import { Injectable } from '@angular/core';
import { SessionService } from '@app/core/services/session/session.service';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DivisionFilter {
  [sectionId: string]: string[];
}

export interface DivisionContext {
  filter: DivisionFilter;
  divisions: string[];
}

@Injectable({
  providedIn: 'root'
})
export class DivisionContextService {
  divisionFilter$: BehaviorSubject<DivisionContext>;
  enabled = true;
  includeGlobalDivisions = true;

  constructor(protected sessionService: SessionService) {
    this.divisionFilter$ = new BehaviorSubject<DivisionContext>(this.sessionService.getDivisionContext());
  }

  resetDivisionFilter(): void {
    this.setDivisionFilter({ filter: {}, divisions: [] });
  }

  getDivisionFilter(): Observable<DivisionContext> {
    return this.divisionFilter$.asObservable();
  }

  setDivisionFilter(filter: DivisionContext): void {
    this.divisionFilter$.next(filter);
    this.sessionService.setDivisionContext(filter);
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  isGlobalDivisions(): boolean {
    return this.includeGlobalDivisions;
  }

  setGlobalDivisions(includeGlobalDivisions: boolean) {
    this.includeGlobalDivisions = includeGlobalDivisions;
  }
}
